<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title d-inline">
      {{ 'ssab.claims.delete.document.modal.heading'|cxTranslate }}
    </h3>
    <i class="float-right icon-md ssab-icon icon-navigation-close icon-inline" (click)="closeDialog(false)"></i>
  </div>
  <div class="modal-body">
    <p>{{ 'ssab.claims.delete.document.modal.text'|cxTranslate }}</p>

    <div class="buttons d-flex justify-content-end ">
      <button
        type="button"
        (click)="closeDialog(false)"
        class="btn btn-link text-uppercase ">
        {{ 'common.cancel'|cxTranslate }}
      </button>
      <button
        type="button"
        (click)="closeDialog(true)"
        class="btn btn-primary ml-4">
        {{ 'ssab.claims.delete.document.modal.deleteFile'|cxTranslate }}
      </button>
    </div>
  </div>
</div>

